var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _path18, _path19, _path20, _path21, _path22, _path23, _path24, _path25;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgTravelneutral(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 100,
    height: 100,
    viewBox: "0 0 100 100",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M0 100H100V0H0V100Z",
    fill: "white",
    fillOpacity: 0.01
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M86.2755 54.6705C86.2755 55.8419 85.8095 56.9651 84.9801 57.7923C84.1508 58.6195 83.0264 59.0827 81.8551 59.0796H68.8778C65.6482 59.067 63.0165 61.6683 62.9914 64.8978V77.9205C62.9914 80.3619 61.0123 82.341 58.571 82.341H32.1164C30.7738 82.3397 29.4911 81.7847 28.571 80.8069C27.6218 79.808 27.0964 78.4803 27.1051 77.1024V11.8296C27.1104 10.4878 27.6648 9.20667 28.6392 8.28418C29.6429 7.33532 30.9739 6.81023 32.3551 6.81827H81.2187C82.5695 6.81192 83.8622 7.36766 84.7869 8.35236C85.7358 9.35605 86.2608 10.6871 86.2528 12.0683L86.2755 54.6705Z",
    fill: "white"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M79.821 20.2955C79.821 23.8728 76.921 26.7728 73.3437 26.7728C69.7664 26.7728 66.8665 23.8728 66.8665 20.2955C66.8665 16.7182 69.7664 13.8182 73.3437 13.8182C76.9184 13.8245 79.8147 16.7208 79.821 20.2955Z",
    fill: "#E9573D"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M36.7983 16.7615H52.3551C53.4283 16.7615 54.2983 17.6315 54.2983 18.7047C54.2921 19.7753 53.4257 20.6416 52.3551 20.6478H36.7983C35.7277 20.6416 34.8613 19.7753 34.8551 18.7047C34.8551 17.6315 35.7251 16.7615 36.7983 16.7615V16.7615Z",
    fill: "#6F7072"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M36.7983 23.2387H58.8324C59.903 23.2449 60.7693 24.1113 60.7756 25.1819C60.7693 26.2525 59.903 27.1189 58.8324 27.1251H36.7983C35.7277 27.1189 34.8613 26.2525 34.8551 25.1819C34.8613 24.1113 35.7277 23.2449 36.7983 23.2387V23.2387Z",
    fill: "#CCCCCC"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M36.7983 33.6024H66.6051C67.6783 33.6024 68.5483 34.4723 68.5483 35.5455C68.5513 36.0618 68.3476 36.5579 67.9825 36.9229C67.6174 37.288 67.1214 37.4918 66.6051 37.4887H36.7983C35.7251 37.4887 34.8551 36.6187 34.8551 35.5455C34.8613 34.4749 35.7277 33.6086 36.7983 33.6024V33.6024Z",
    fill: "#EBEBEB"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M36.7983 40.0797H76.9687C78.0419 40.0797 78.9119 40.9496 78.9119 42.0228C78.915 42.5391 78.7112 43.0352 78.3461 43.4002C77.9811 43.7653 77.485 43.9691 76.9687 43.966H36.7983C35.7251 43.966 34.8551 43.096 34.8551 42.0228C34.8613 40.9522 35.7277 40.0859 36.7983 40.0797Z",
    fill: "#EBEBEB"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M36.7983 46.5683H76.9687C77.485 46.5652 77.9811 46.769 78.3461 47.1341C78.7112 47.4991 78.915 47.9952 78.9119 48.5115C78.9119 49.5846 78.0419 50.4546 76.9687 50.4546H36.7983C35.7277 50.4484 34.8613 49.5821 34.8551 48.5115C34.8551 47.4383 35.7251 46.5683 36.7983 46.5683Z",
    fill: "#EBEBEB"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M36.7983 59.5228H52.3551C52.8744 59.5228 53.3722 59.7306 53.7372 60.1C54.1023 60.4693 54.3044 60.9694 54.2983 61.4887C54.2921 62.5593 53.4257 63.4257 52.3551 63.4319H36.7983C35.7277 63.4257 34.8613 62.5593 34.8551 61.4887C34.849 60.9694 35.0511 60.4693 35.4162 60.1C35.7812 59.7306 36.279 59.5228 36.7983 59.5228V59.5228Z",
    fill: "#CCCCCC"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M61.696 81.0456C62.523 80.2155 62.9886 79.0923 62.9915 77.9206V64.8978C62.9945 63.3407 63.6167 61.8488 64.721 60.7509C65.8252 59.6531 67.3208 59.0395 68.8779 59.0456H81.8551C83.0262 59.0507 84.151 58.5885 84.9801 57.7615L61.696 81.0456Z",
    fill: "#CCCCCC"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M26.8324 39.2842C37.3844 39.5393 45.8056 48.1666 45.8056 58.7217C45.8056 69.2767 37.3844 77.904 26.8324 78.1592V39.2842Z",
    fill: "#CCCCCC"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M41.0596 52.466C37.6139 44.302 28.2025 40.4768 20.0384 43.9222C11.8742 47.3675 8.04864 56.7788 11.4936 64.9431C14.9386 73.1074 24.3497 76.9334 32.5142 73.4887C40.666 70.0301 44.4789 60.6248 41.0369 52.466",
    fill: "#E9573D"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M41.0596 52.466C37.6139 44.302 28.2025 40.4768 20.0384 43.9222C11.8742 47.3675 8.04864 56.7788 11.4936 64.9431C14.9386 73.1074 24.3497 76.9334 32.5142 73.4887C40.6748 70.0389 44.499 60.6311 41.0596 52.466V52.466Z",
    stroke: "#C21B17",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M86.2755 17.4319V12.091C86.278 10.7032 85.7447 9.36798 84.7869 8.36372C83.8741 7.38747 82.6006 6.82876 81.2641 6.81827H32.4005C31.0193 6.81023 29.6883 7.33532 28.6846 8.28418C27.7122 9.21749 27.1589 10.5046 27.1505 11.8524V39.1251",
    stroke: "#C21B17",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M27.1051 75.1251V77.3978C27.0965 78.7825 27.6214 80.1173 28.571 81.1251C29.4848 82.1147 30.7695 82.6788 32.1164 82.6819H58.571C59.7461 82.6849 60.8728 82.2137 61.696 81.3751C62.5247 80.5415 62.9903 79.4142 62.9914 78.2387V65.2046C62.9914 63.646 63.6083 62.1507 64.7074 61.0455C65.8077 59.9309 67.3116 59.308 68.8778 59.3183H81.8551C83.0204 59.3393 84.1456 58.8933 84.9801 58.0796C85.813 57.2489 86.2794 56.1197 86.2755 54.9433V28.5342",
    stroke: "#C21B17",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "M84.9801 58.0115L61.696 81.4206",
    stroke: "#C21B17",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M80.2415 20.3751C80.2227 24.1926 77.116 27.2739 73.2984 27.2614C69.4808 27.2489 66.3944 24.1473 66.4006 20.3297C66.4069 16.5121 69.5034 13.4206 73.321 13.4205C77.1512 13.4331 80.2478 16.5449 80.2415 20.3751Z",
    stroke: "#C21B17",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    d: "M90.8324 16.5683C90.0669 16.0784 89.0865 16.0784 88.321 16.5683L87.5596 17.0569C86.8012 17.5564 85.8181 17.5564 85.0596 17.0569L84.2983 16.5683C83.5398 16.0688 82.5568 16.0688 81.7983 16.5683L81.0369 17.0569C80.6166 17.3317 80.1171 17.4596 79.6165 17.4206",
    stroke: "#C21B17",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    d: "M90.8323 20.1251C90.0668 19.6353 89.0863 19.6353 88.3209 20.1251L87.5595 20.6138C86.801 21.1133 85.818 21.1133 85.0595 20.6138L84.2982 20.1251C83.5397 19.6256 82.5566 19.6256 81.7982 20.1251L81.0368 20.5797C80.7905 20.7383 80.5169 20.8501 80.23 20.9092",
    stroke: "#C21B17",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    d: "M90.8324 23.6819C90.0669 23.192 89.0865 23.192 88.321 23.6819L87.5596 24.1705C86.8012 24.67 85.8181 24.67 85.0596 24.1705L84.2983 23.6819C83.5398 23.1824 82.5568 23.1824 81.7983 23.6819L81.0369 24.1705C80.4273 24.5597 79.6716 24.6436 78.9915 24.3978",
    stroke: "#C21B17",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    d: "M37.4232 93.8864H61.605",
    stroke: "#C21B17",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    d: "M67.4688 93.8864H73.8778",
    stroke: "#C21B17",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path23 || (_path23 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M76.73 20.3751C76.73 22.2579 75.2037 23.7842 73.321 23.7842C71.4382 23.7842 69.9119 22.2579 69.9119 20.3751C69.9119 18.4923 71.4382 16.966 73.321 16.966C75.2037 16.966 76.73 18.4923 76.73 20.3751Z",
    stroke: "#C21B17",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path24 || (_path24 = /*#__PURE__*/React.createElement("path", {
    d: "M28.5255 60.7501L32.2301 64.7274C32.7161 65.2038 33.494 65.2038 33.9801 64.7274L37.7414 60.9546C37.9731 60.713 38.1033 60.3917 38.1051 60.0569C38.0855 59.5488 37.7654 59.1011 37.291 58.9182C36.8165 58.7353 36.2787 58.8524 35.9232 59.216L34.3437 60.7955V54.6705C34.2817 54.0171 33.733 53.5179 33.0766 53.5179C32.4203 53.5179 31.8715 54.0171 31.8096 54.6705V60.6251L30.3096 58.9887C29.8096 58.514 29.0255 58.514 28.5255 58.9887C28.0579 59.4871 28.0579 60.2631 28.5255 60.7615V60.7501Z",
    fill: "white"
  })), _path25 || (_path25 = /*#__PURE__*/React.createElement("path", {
    d: "M24.0142 57.7387L20.3097 53.7501C19.8261 53.2675 19.0432 53.2675 18.5597 53.7501L14.7983 57.5228C14.3025 58.0217 14.305 58.8281 14.804 59.3239C15.3029 59.8197 16.1093 59.8172 16.6051 59.3182L18.1847 57.7273V63.8182C18.139 64.2996 18.37 64.7652 18.7809 65.02C19.1918 65.2748 19.7116 65.2748 20.1225 65.02C20.5334 64.7652 20.7644 64.2996 20.7187 63.8182V57.8637L22.2187 59.5001C22.7187 59.9748 23.5029 59.9748 24.0028 59.5001C24.2429 59.263 24.3779 58.9397 24.3778 58.6023C24.3686 58.2792 24.2389 57.9711 24.0142 57.7387Z",
    fill: "white"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgTravelneutral);
export default __webpack_public_path__ + "static/media/Travel neutral.d5383341.svg";
export { ForwardRef as ReactComponent };